import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
// Models
import { TableButton } from '../../_models/table-buttons';
import { DocumentTableColumn } from '../../_models/document';
// Services
import { TextFiltersService } from '../../_services/text-filters.service';
import { DynamicTableService } from '../../_services/dynamic-table.service';
import { DocumentsService } from 'src/app/_services/documents.service';

@Component({
  standalone: false,
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {

  constructor(
    private textFiltersService: TextFiltersService,
    private documentsService: DocumentsService,
    private dynamicTableService: DynamicTableService
  ) { }

  // Inputs
  @Input() columnNames: Array<string>;
  @Input() tableData: Array<object>;
  @Input() textFilters: Array<string>;
  // Outputs
  @Output() sendButtonInfo = new EventEmitter<TableButton>();
  @Output() syncDocuments = new EventEmitter();
  // Local variables
  searchedWord: string = '';
  textFilters$: Observable<Array<string>>;
  columnsConfig$: Observable<DocumentTableColumn[]>;
  buttonsConfig$: Observable<TableButton[]>;
  currentPage: number = 1;


  ngOnInit(): void {
    this.textFilters$ = this.textFiltersService.textFilters$;
    this.columnsConfig$ = this.dynamicTableService.tableColumns$;
    this.buttonsConfig$ = this.dynamicTableService.buttonsConfig$;
  }

  public updateSearchedWord(text) {
    this.searchedWord = text;
    this.tableData = this.documentsService.getDocumentsValue();
  }

  public getButtonInfo(btn) {
    const btnInfo: TableButton = btn;
    this.sendButtonInfo.emit(btn);
  }

  public updateTextFilters(value) {
    this.textFiltersService.updateFilters(value);
    this.tableData = this.documentsService.getDocumentsValue();
  }

  public deleteTextFilters(value) {
    this.textFiltersService.deleteFilters(value);
    this.tableData = this.documentsService.getDocumentsValue();
  }

  refreshDocuments() {
    this.syncDocuments.emit();
  }
}
